import React from "react";
import { Link } from "react-router-dom";

import Reveal from "../../../components/Reveal";

export default function CatalogueTeaser() {
  return (
    <div className="max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <p className="font-accent text-gold-700 text-xs tracking-[0.35em] uppercase mb-4">
          Just Dropped
        </p>
      </Reveal>

      <Reveal delay={150}>
        <h2 className="font-heading uppercase text-maroon-800 text-3xl sm:text-4xl md:text-5xl tracking-wide leading-tight">
          Explore The Catalogue
        </h2>
      </Reveal>

      <Reveal delay={300}>
        <p className="font-body font-medium text-maroon-900/90 text-base sm:text-lg mt-6 leading-relaxed max-w-2xl mx-auto">
          A living archive of everything we weave — browse the full collection, curated and constantly evolving.
        </p>
      </Reveal>

      <Reveal delay={450}>
        <Link
          to="/catalogue"
          className="inline-block mt-10 rounded-sm border-2 border-maroon-700 bg-maroon-700 text-cream-100 font-accent tracking-[0.2em] uppercase text-xs px-12 py-4 shadow-lg hover:bg-transparent hover:text-maroon-700 transition-colors duration-500"
        >
          View Catalogue
        </Link>
      </Reveal>
    </div>
  );
}
